export default "/assets/images/mila-feed-07-thumbnail.49265210d4af9417.jpg";